import React from 'react';
import { CountryCode } from '@dayetopia/types';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import NewsletterFormAlt from '@components/shared/NewsletterFormAlt';
import { getKlaviyoTrackingListId } from '@utils/helpers';

interface Props {
  country: CountryCode;
  className: string;
}

const ArticleNewsletterForm = ({ country, className }: Props) => {
  const { t } = useTranslation();

  return (
    <Container className={className}>
      <TextRowWrap>
        <Typography $variant={TextVariant.Heading6}>{t('components.vitals-newsletter.title')}</Typography>
        <Typography $variant={TextVariant.BodyRegularLG}>{t('components.vitals-newsletter.subtitle')}</Typography>
      </TextRowWrap>
      <EmailRowWrap>
        <NewsletterFormAlt
          textColor={Colors.navyBlue}
          buttonText={t('components.subscription-options.subscribe')}
          listId={getKlaviyoTrackingListId(country)}
        />
        <StyledBodySM $variant={TextVariant.BodyRegularMD}>{t('components.vms-founders-results.note')}</StyledBodySM>
      </EmailRowWrap>
    </Container>
  );
};

export default ArticleNewsletterForm;

const Container = styled.div`
  background: ${Colors.paleGold25};
  display: flex;
  padding: 32px 24px;
  margin: 56px 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
`;

const TextRowWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  color: ${Colors.navyBlue};
`;

const EmailRowWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  color: ${Colors.navyBlue};
`;

const StyledBodySM = styled(Typography)`
  opacity: 0.5;
`;
